import React from 'react';
import { ArticleBlockContentGridCol } from '../ArticleBlockContentGridCol';
import { DataWrapperBlock } from './DataWrapperBlock';
import { BlockContentContext } from '../../../../BlockContent.utils';

interface DataWrapperSerializerProps {
  value: { ariaLabel: string; chartId: string; title: string; _type: string; _key: string };
}

export const DataWrapperSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: DataWrapperSerializerProps) => (
      <ArticleBlockContentGridCol>
        <DataWrapperBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: DataWrapperSerializerProps) => <DataWrapperBlock value={value} />;
};
